import api from './api';
import { DataItem } from '../components/TabelaConciliadorBancario/types';

interface ResponseDTO<T> {
    result: T;
    message: string;
    success: boolean;
}

export interface ConciliadorBancarioFiltro {
    StartIndex?: number;
    PageSize?: number;
    Empresa?: string;
    Cnpj?: string;
    Adquirente?: string;
    Bandeira?: string;
    Banco?: string;
    Agencia?: string;
    Conta?: string;
    StatusPgto?: string;
    StatusConciliacao?: string;
    Justificativa?: string;
    DataPgtoInicio?: string;
    DataPgtoFim?: string;
}

export interface ConciliadorBancarioPaginado {
    result: DataItem[];
    totalCount: number;
    statusPgtoOpcoes?: string[];
    statusConciliacaoOpcoes?: string[];
    adquirentes?: string[];
    bandeiras?: string[];
    bancos?: string[];
    agencias?: string[];
    contas?: string[];
    empresas?: string[];
    cnpjs?: string[];
}

export async function getConciliadorBancarioByGroup(
    group: string,
    filtro?: ConciliadorBancarioFiltro
): Promise<ConciliadorBancarioPaginado> {
    const response = await api.get<ResponseDTO<ConciliadorBancarioPaginado>>(
        `/ConciliadorBancario/get-all-conciliador-bancario-by-group/${encodeURIComponent(group)}`,
        { params: filtro }
    );
    return response.data?.result ?? { result: [], totalCount: 0, options: {} as any };
}

export async function conciliarManual(
    group: string,
    administradora: string,
    justificativa: string,
    filtro: ConciliadorBancarioFiltro
): Promise<ResponseDTO<unknown>> {
    const response = await api.post<ResponseDTO<unknown>>(
        `/ConciliadorBancario/conciliar-manual`,
        { group, administradora, justificativa, filtro }
    );
    return response.data;
}

export interface AjusteConciliadorBancario {
    dataLancamento: string;
    tipoLancamento: string;
    motivo: string;
    valor: string;
    nsucv: string;
    codigoDeAutorizacao: string;
    numeroDaParcela: string;
    tid: string;
}

export async function getAjustesConciliadorBancario(
    adquirente: string,
    cnpj: string,
    dataPgto: string
): Promise<AjusteConciliadorBancario[]> {
    const response = await api.get<ResponseDTO<AjusteConciliadorBancario[]>>(
        `/ConciliadorBancario/ajustes`,
        { params: { adquirente, cnpj, dataPgto } }
    );
    return response.data?.result ?? [];
}

export async function desfazerConciliacaoManual(
    group: string,
    administradora: string | null,
    filtro: ConciliadorBancarioFiltro
): Promise<ResponseDTO<unknown>> {
    const response = await api.post<ResponseDTO<unknown>>(
        `/ConciliadorBancario/desfazer-conciliacao-manual`,
        { group, administradora, filtro }
    );
    return response.data;
}